
export const parseSpainFormatDate = (date)=>{
    let d = new Date(date);
    let s = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear();
    return s;
};